<template>
  <div class="min-h-full relative flex flex-col bg-gray-100">
    <nav class="bg-white">
      <ul class="flex">
        <li class="px-5 py-3 uppercase tracking-wider bg-blue-400 text-white">
          Company Settings:
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-general' }"
            class="block h-full px-8 py-3"
            active-class="bg-gray-200"
            >General</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-users' }"
            class="block h-full px-8 py-3"
            active-class="bg-gray-200"
            >Users</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-campaigns' }"
            class="block h-full px-8 py-3"
            active-class="bg-gray-200"
            >Campaigns</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-domains' }"
            class="block h-full px-8 py-3"
            active-class="bg-gray-200"
            >Domains</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-parameters-custom' }"
            class="block h-full px-8 py-3"
            active-class="bg-gray-200"
            >Parameters</router-link
          >
        </li>
        <li>
          <router-link
            :to="{ name: 'admin-export' }"
            class="block h-full px-8 py-3"
            active-class="bg-gray-200"
            >Export</router-link
          >
        </li>
      </ul>
    </nav>
    <div class="flex-1 bg-gray-200 p-8">
      <div v-if="fetchingCompanies" class="text-blue-400">
        <base-loading class="block text-3xl" />
        Loading
      </div>
      <router-view v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      fetchingCompanies: (state) => state.company.fetchingList,
    }),
  },
};
</script>
